module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": 'md',
      "title": "Secret identity",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "bg-gray-100 py-7"
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('img', {
    staticClass: "w-14 h-14 rounded-full object-cover mb-2",
    attrs: {
      "src": _vm.anonymous_identity.avatar_url
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-center text-gray-800"
  }, [_vm._v(_vm._s(_vm.anonymous_identity.name))])]), _vm._v(" "), _c('div', {
    staticClass: "text-sm font-light px-12 py-8 mb-10 leading-6 overflow-y-auto",
    domProps: {
      "innerHTML": _vm._s(_vm.anonymous_identity.description)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-75df11f9!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/anonymousCharacterDescriptionModal.vue
// module id = 1063
// module chunks = 61